// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"c16f89c8","750":"18126641"}[chunkId] + ".chunk.css";
};